import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import TaskSkeleton from "./TaskSkeleton";

export default function Yourtask() {
  const { http, user } = AuthUser();
  const [tasks, setTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [date, setDate] = useState(null);
  const [dept, setDept] = useState("Pending");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedAssignedTo, setSelectedAssignedTo] = useState("");
  const [users, setUsers] = useState([]);
  const [remark, setRemark] = useState(null);
  const [departments, setdepartments] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [bulkStatus, setBulkStatus] = useState("");
  const [bulkLoading, setBulkLoading] = useState(false);
  const [loginUser, setloginUser] = useState(user.department_id);
  const [showModal, setShowModal] = useState(false);
  const [showModalRevise, setShowModalRevise] = useState(false);
  const [ModalId, setModalId] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [note, setNote] = useState("");
  const [noteTaskId, setNoteTaskId] = useState(null);

  // New state for remarks modal
  const [showRemarksModal, setShowRemarksModal] = useState(false);
  const [remarksData, setRemarksData] = useState("");

  useEffect(() => {
    http.get(`/department_user_company?login_user=${user.id}`).then((res) => {
      setUsers(res.data.users || []);
    });
    http.get("/departments").then((res) => {
      setdepartments(res.data.data);
    });
  }, [user.id]);

  useEffect(() => {
    fetchTaskDetails();
  }, [dept, selectedDepartment, selectedAssignedTo]);

  const fetchTaskDetails = () => {
    setIsLoading(true);
    let endpoint = `/tasks_user_you=${user.id}?dept=${dept}&department=${selectedDepartment}&assigned_to=${selectedAssignedTo}`;

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
          setSelectedIds([]);
        } else {
          setIsLoading(false);
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });
  };

  const allSelected =
    tasks.length > 0 && selectedIds.length === tasks.length;

  const toggleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(tasks.map((t) => t.id));
    } else {
      setSelectedIds([]);
    }
  };

  const toggleSelectOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleBulkUpdate = async () => {
    if (selectedIds.length === 0) {
      toast.error("Please select at least one task");
      return;
    }
    if (!bulkStatus) {
      toast.error("Please select a status to update");
      return;
    }
    setBulkLoading(true);
    try {
      const res = await http.put("/task_status_bulk_update", {
        task_ids: selectedIds,
        status: bulkStatus,
      });
      toast.success(res.data?.message || "Tasks updated successfully");
      setBulkStatus("");
      setSelectedIds([]);
      fetchTaskDetails();
    } catch (error) {
      toast.error(error.response?.data?.message || "Bulk update failed");
    } finally {
      setBulkLoading(false);
    }
  };

  const openModal = (taskId) => {
    setShowModal(true);
    setModalId(taskId);
  };

  const openModalRevise = (rmark, revisedate) => {
    setDate(revisedate);
    setRemark(rmark);
    setShowModalRevise(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setShowModalRevise(false);
    setShowNoteModal(false);
    setShowRemarksModal(false); // Close remarks modal
  };

  const handleChange = (event) => {
    setSelectedDepartment(event.target.value);
  };

  const handleChangeAssignedTo = (event) => {
    setSelectedAssignedTo(event.target.value);
  };

  const handleChangeDept = async (event) => {
    const status = event.target.value;
    if (status === "") setDept("Pending");
    else setDept(status);
  };

  const statusUpdate = (e) => {
    setCurrentStatus(e.target.value);
  };

  const handleSave = async (taskId) => {
    if (currentStatus === null || taskId === null) {
      toast.error("Please select proper status");
      return true;
    }
    try {
      const response = await http.put(
        `task_status_update?task_id=${taskId}&status=${encodeURIComponent(
          currentStatus
        )}`
      );
      toast.success("Task status updated successfully !");
      fetchTaskDetails();
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Please select proper item");
    }
  };

  const [formData, setFormData] = useState({
    revised_date: "",
    revised_remark: "",
  });
  const initialState = {
    revised_date: "",
    revised_remark: "",
  };

  const handleChangeModal = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      http.put(`/revise/${ModalId}`, formData).then((res) => {
        toast.success("revise date added successfully !");
        setFormData(initialState);
        fetchTaskDetails();
        closeModal();
      });
    } catch (error) {
      console.error("Error adding task:", error.response.data);
    }
  };

  const deleteTask = async (taskId) => {
    await http
      .delete(`/tasks/${taskId}`)
      .then((response) => {
        toast.success("Task Deleted successfully !");
        fetchTaskDetails();
      })
      .catch((err) => {
        console.error("Error deleting task", err);
      });
  };

  const openNoteModal = (taskId) => {
    setNoteTaskId(taskId);
    setShowNoteModal(true);
  };

  const handleNoteSubmit = async (e) => {
    e.preventDefault();
    try {
      await http.post(`/save_remark`, { task_id: noteTaskId, remarks: note });
      toast.success("Note added successfully!");
      setNote("");
      closeModal();
    } catch (error) {
      console.error("Error adding note:", error);
    }
  };

  // New function to open remarks modal
  const openRemarksModal = (remarks) => {
    setRemarksData(remarks);
    setShowRemarksModal(true);
  };

  return (
    <>
      <Toaster />
      {showModalRevise && (
        <div className="modal" tabindex="-1" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Revision Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group  mt-3">
                  <label>New Revision Date</label>
                  <input
                    name="revised_date"
                    className="form-control"
                    type="date"
                    value={date}
                  />
                </div>

                <div className="form-group mt-3">
                  <label>Revision Note</label>
                  <textarea
                    name="revised_remark"
                    className="form-control"
                    rows="3"
                    value={remark}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showNoteModal && (
        <div className="modal" tabindex="-1" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Note</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group mt-3">
                  <label>Note</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleNoteSubmit}
                >
                  Save Note
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Remarks Modal */}
      {showRemarksModal && (
        <div className="modal" tabindex="-1" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Remarks</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <p>{remarksData}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container mt-1">
        <div className="row">
          <div className="col-md-4">
            <h1 className="mb-4">Tasks Added By You</h1>
          </div>
          <div className="col-md-8">
            <div className="row">
              {user && user.department_id == 1 && (
                <div className="col-md-4">
                  <div className="form-group text-end">
                    <select
                      onChange={handleChange}
                      value={selectedDepartment}
                      className="form-control mb-1"
                    >
                      <option value="">All Department</option>
                      {departments.map((depart) => (
                        <option key={depart.id} value={depart.id}>
                          {depart.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
              <div className={user && user.department_id == 1 ? "col-md-4" : "col-md-6"}>
                <div className="form-group text-end">
                  <select
                    onChange={handleChangeAssignedTo}
                    value={selectedAssignedTo}
                    className="form-control mb-1 text-uppercase"
                  >
                    <option value="">Assigned To</option>
                    {users.map((u) => (
                      <option key={u.id} value={u.id}>
                        {u.name} {u.last_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className={user && user.department_id == 1 ? "col-md-4" : "col-md-6"}>
                <div className="form-group text-end">
                  <select onChange={handleChangeDept} className="form-control mb-1" value={dept}>
                    <option value="Pending">Pending</option>
                    <option value="Completed">Completed</option>
                    <option value="Finished">Finished</option>
                    <option value="Progress">Progress</option>
                    <option value="Delayed">Delayed</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        {selectedIds.length > 0 && (
          <div className="d-flex flex-wrap align-items-center gap-2 mb-3 p-2 border rounded bg-light">
            <strong className="me-2">{selectedIds.length} selected</strong>
            <select
              className="form-select form-select-sm"
              style={{ maxWidth: "180px" }}
              value={bulkStatus}
              onChange={(e) => setBulkStatus(e.target.value)}
            >
              <option value="">Set Status</option>
              <option value="Pending">Pending</option>
              <option value="Completed">Completed</option>
            </select>
            <button
              type="button"
              className="btn btn-sm btn-primary"
              disabled={bulkLoading}
              onClick={handleBulkUpdate}
            >
              {bulkLoading ? "Updating..." : "Update Selected"}
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => {
                setSelectedIds([]);
                setBulkStatus("");
              }}
            >
              Clear
            </button>
          </div>
        )}

        <div className="table-responsive">
          {isLoading ? (
            <TaskSkeleton />
          ) : (
            <table className="table table-striped">
              <thead className="table-primary">
                <tr>
                  <th style={{ width: "40px" }}>
                    <input
                      type="checkbox"
                      checked={allSelected}
                      onChange={toggleSelectAll}
                      title="Select all"
                    />
                  </th>
                  <th>No</th>
                  <th className="text-danger">Created On</th>
                  <th>Description</th>
                  <th>Department</th>
                  <th width="100px">Status</th>
                  <th>info</th>
                  <th width="100px">Due Date</th>
                  <th>Weightage</th>
                  <th>Priority</th>
                  <th>Assigned By</th>
                  <th>Assigned To</th>


                  <th width="260px">Action</th>

                  {/* Add other fields as necessary */}
                </tr>
              </thead>
              <tbody>
                {tasks.map((user, index) => (
                  <tr key={user.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(user.id)}
                        onChange={() => toggleSelectOne(user.id)}
                      />
                    </td>
                    <td>T{index + 1}</td>
                    <td>{moment(user.created_at).format("DD MMM,YY hh:mm A")}</td>
                    <td>{user.description}</td>
                    <td>{user.department?.name}</td>
                    <td>
                      {" "}
                      {user.status === "Completed" && (
                        <span className="badge bg-success font-size-13">
                          Completed
                        </span>
                      )}

                      {user.status === "Finished" && (
                        <span className="badge bg-primary font-size-13">
                          Finished
                        </span>
                      )}
                      {user.status === "Pending" && (
                        <span className="badge bg-danger font-size-13">
                          Pending
                        </span>
                      )}
                      {user.status === "Progress" && (
                        <span className="badge bg-secondary font-size-13">
                          Progress
                        </span>
                      )}
                      {user.status === "Delayed" && (
                        <span className="badge bg-secondary font-size-13">
                          Delayed
                        </span>
                      )}
                      {' '}
                      {user.remarks ? (
                        <span
                          className="badge bg-danger"
                          onClick={() => openRemarksModal(user.remarks)} // Open remarks modal on click
                          style={{ cursor: "pointer" }}
                        >
                          N
                        </span>
                      ) : null}
                    </td>
                    <td>{user.additional_info}</td>
                    <td>
                      {moment(user.target_date).format("DD MMM,YY")}{" "}
                      {user.is_revised == 1 && (
                        <a
                          href="#"
                          className="badge bg-danger font-size-13"
                          onClick={() =>
                            openModalRevise(
                              user.revised_remark,
                              user.revised_date
                            )
                          }
                        >
                          R
                        </a>
                      )}
                    </td>

                    <td>{user.task_weightage}</td>
                    <td>{user.priority}</td>
                    <td>
                      {user.assigner?.name} {user.assigner?.last_name}
                    </td>
                    <td>
                      {user.assignee?.name} {user.assignee?.last_name}
                    </td>
                    <td>
                      <>
                        <select
                          onChange={statusUpdate}
                          className="form-select-sm mb-2"
                        >
                          <option value="">Status</option>
                          <option value="Pending">Pending</option>
                          <option value="Completed">Completed</option>
                        </select>
                        <button
                          className="btn-sm btn btn-link"
                          onClick={() => handleSave(user.id)}
                        >
                          Save
                        </button>
                      </>

                      <button
                        className="button btn-sm btn-danger"
                        onClick={() => deleteTask(user.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
